import React, { useState, useRef } from 'react';
import { BsThreeDotsVertical } from "react-icons/bs";
import { formatNumberUtil } from '../../../../../Utils/localStorageUtils';
import SharePropertyModal from '../../../../../Components/SharePropertyModal/SharePropertyModal';
import { useParams } from 'react-router-dom';
import { API_BASE_URL, APP_BASE_URL } from '../../../../../Utils/constants';

const HeaderSection = ({ Price, EMI, Title ,propertyData }) => {
   const {propertyId} = useParams()
  const [showOptions, setShowOptions] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const optionsRef = useRef(null);

  const handleOnClose = () => setIsShareModalOpen(false);



  // Generate Title dynamically
  const generatedTitle = () => {
    const { bedrooms } = propertyData?.aboutProperty?.roomDetails || {};
    const propertyType = propertyData?.basicDetails?.additionalOption?.value || "Property";
    const lookingTo = propertyData?.basicDetails?.lookingTo || "Sale";
    const location = propertyData?.locationDetails?.apartmentSociety || propertyData?.locationDetails?.locality || "";
  
    return `${bedrooms ? bedrooms + " BHK" : ""} ${propertyType} for ${lookingTo}${location ? ` in ${location}` : ""}`.trim();
  };
  


  return (
    <div>
      <div className="bg-white p-4 rounded-lg font-montserrat relative">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
          <div className="text-lg font-semibold">
            {Price ? `₹ ${formatNumberUtil(Price)}` : "₹ 46.0 Lac"} 
            <span className="text-sm text-gray-600">
              {EMI.available && `EMI - ₹${EMI.perMonth && formatNumberUtil(EMI.perMonth)}`}
            </span>
          </div>
          <div 
            className="relative  rounded-md  hover:bg-gray-200"
            onMouseEnter={() => setShowOptions(true)}
            onMouseLeave={() => setShowOptions(false)}
          >
            <button 
              className="text-gray-700 hover:text-gray-900 transition duration-300"
            >
              <BsThreeDotsVertical size={24} />
            </button>
            {showOptions && (
              <div 
                className="absolute right-0 top-full  w-48 bg-white shadow-lg rounded-lg p-2 text-sm border"
              >
                <button 
                  className="w-full text-left px-4 py-2 hover:bg-gray-100"
                  onClick={() => setIsShareModalOpen(true)}
                >
                  Share Property
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="text-gray-800">
        {Title || generatedTitle()}
        </div>
      </div>

      {isShareModalOpen && (
        <SharePropertyModal
          isOpen={isShareModalOpen}
          onClose={handleOnClose}
          shareUrl={`${APP_BASE_URL}/property/${propertyId}`} // Dynamic property link
        />
      )}
    </div>
  );
}

export default HeaderSection;
